export interface Plan {
  id: string;
  name: string;
  data: string;
  price: number;
  isTop?: boolean;
}

export interface Discount {
  id: string;
  label: string;
  type: "flat" | "percent" | "free";
  value: number;
  duration: number; // in Monaten
}

export interface OmoStep {
  label: string;
  reduction: number;
  marginEffect: number;
}

export const discounts: Discount[] = [
  { id: "none", label: "Kein Rabatt", type: "flat", value: 0, duration: 0 },
  { id: "minus10", label: "-10€", type: "flat", value: 10, duration: 24 },
  { id: "flat6", label: "6M gratis", type: "free", value: 0, duration: 6 },
  { id: "flat12", label: "12M gratis", type: "free", value: 0, duration: 12 },
  { id: "perc50", label: "-50%", type: "percent", value: 50, duration: 12 },
  { id: "perc25", label: "-25%", type: "percent", value: 25, duration: 24 },
];

export const omoSteps: OmoStep[] = [
  { label: "Kein OMO", reduction: 0, marginEffect: -350 },
  { label: "OMO 5%", reduction: 0.05, marginEffect: -332.5 },
  { label: "OMO 10%", reduction: 0.1, marginEffect: -315 },
  { label: "OMO 15%", reduction: 0.15, marginEffect: -297.5 },
  { label: "OMO 17,5%", reduction: 0.175, marginEffect: -288.75 },
  { label: "OMO 20%", reduction: 0.2, marginEffect: -280 },
  { label: "OMO 25%", reduction: 0.25, marginEffect: -262.5 },
  { label: "OMO 30%", reduction: 0.3, marginEffect: -245 },
  { label: "OMO 35%", reduction: 0.35, marginEffect: -227.5 },
];

export const mockPlans: Plan[] = [
  { id: "p1", name: "Business Prime S", data: "20 GB", price: 29.0 },
  { id: "p2", name: "Business Prime M", data: "50 GB", price: 42.0 },
  { id: "p3", name: "Business Prime L", data: "200 GB", price: 49.0 },
  { id: "p4", name: "Business Prime XL", data: "Unlimited", price: 59.0 },
  { id: "p5", name: "TeamDeal XS", data: "10 GB", price: 9.5, isTop: true },
  { id: "p6", name: "TeamDeal S", data: "20 GB", price: 14.5 },
  { id: "p7", name: "TeamDeal M", data: "50 GB", price: 19.5 },
  { id: "p8", name: "TeamDeal XL", data: "Unlimited", price: 29.5 },
];

export const mockBusinessSmartPlans: Plan[] = [
  { id: "bs1", name: "Business Smart S", data: "1 GB", price: 11.0 },
  { id: "bs2", name: "Business Smart M", data: "5 GB", price: 15.0 },
  { id: "bs3", name: "Business Smart S Flex", data: "1 GB", price: 11.0 },
  {
    id: "bs4",
    name: "Business Smart M Flex",
    data: "5 GB",
    price: 15.0,
    isTop: true,
  },
  { id: "bs5", name: "Smart Business", data: "0.5 GB", price: 9.0 },
  { id: "bs6", name: "Smart Business Plus", data: "1 GB", price: 13.0 },
];

export const mockGigaMobilPlans: Plan[] = [
  { id: "gm1", name: "Vodafone Smart S", data: "65 GB", price: 39.99 },
  { id: "gm2", name: "Vodafone Smart M", data: "85 GB", price: 44.99 },
  { id: "gm3", name: "Vodafone Smart L", data: "105 GB", price: 49.99 },
  { id: "gm4", name: "Vodafone Smart XL", data: "125 GB", price: 54.99 },
  {
    id: "gm5",
    name: "Vodafone GigaMobil XS",
    data: "7 GB",
    price: 29.99,
    isTop: true,
  },
  { id: "gm6", name: "Vodafone GigaMobil S", data: "25 GB", price: 39.99 },
  { id: "gm7", name: "Vodafone GigaMobil M", data: "50 GB", price: 49.99 },
  { id: "gm8", name: "Vodafone GigaMobil L", data: "280 GB", price: 59.99 },
  { id: "gm9", name: "Vodafone GigaMobil XL", data: "Unlimited", price: 79.99 },
];
